import type { McpOAuthGrant } from '@/api/v4/mcp-oauth.api';

export type ConnectionStatus =
  | 'connected'
  | 'error'
  | 'notConnected'
  | 'waiting';

export const getConnectionStatus = (
  grant: McpOAuthGrant | null,
): ConnectionStatus => {
  if (!grant) {
    return 'notConnected';
  }

  if (grant.lastError) {
    return 'error';
  }

  const grantStatus =
    'grantStatus' in grant
      ? (grant as McpOAuthGrant & { grantStatus?: string }).grantStatus
      : null;

  if (grantStatus === 'pending') {
    return 'waiting';
  }

  if (!grant.lastUsedAt) {
    return 'waiting';
  }

  return 'connected';
};

export const getDisplayScopes = (
  scopes: string[],
  t: (key: string) => string,
): string[] => {
  if (scopes.includes('mcp:read')) {
    return [
      t('mcpOAuth.scopeReadDeals'),
      t('mcpOAuth.scopeReadCompanies'),
      t('mcpOAuth.scopeReadReports'),
    ];
  }

  return scopes;
};

export const getClientLabel = (
  grant: McpOAuthGrant,
  t: (key: string) => string,
): string => grant.oauthClientId || t('mcpOAuth.unknownClient');
